/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo} from 'react';
import { useHistory, useParams } from 'react-router-dom';

import {makeStyles, Theme, Container, Grid, Button} from '@material-ui/core';

import { AppContext } from '../stores/AppStore';
// import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';

import LoadingOverlay from '../components/common/LoadingOverlay';

import Plotly from "plotly.js";
import createPlotlyComponent from 'react-plotly.js/factory';
const Plot = createPlotlyComponent(Plotly);

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2,2,0,2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch',
        height: '92vh'
    },
    header: {
        backgroundColor: 'transparent',
        flex: '50px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '10px'
    },
    toolbar: {
        // margin: 2
    },    
    body: {
        backgroundColor: theme.palette.secondary.main,
        flex: '1 0',
        borderRadius: '8px 8px 0 0',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        alignContent: 'flex-start'
    },
    gradientButton: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.primary,
        height: 32,
        borderRadius: '4px',
        background: 'linear-gradient(136.14deg, #009EE0 0%, #172983 100%)',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)',
        textTransform: 'none' 
    },
    viewButton: {
        height: 26,
        width: 70,
        fontSize: 12,
        fontWeight: 500,
        backgroundColor: '#F8F9FA',
        color: theme.palette.primary.main,
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)',
        textTransform: 'none' 
    },    
    title: {
        fontSize: 24,
        fontWeight: 700,
        marginRight: 16,
    },
    card: {
        // minWidth: 310,
        // maxWidth: 310,
        margin: theme.spacing(3,2),
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 8px 16px 0 rgba(0,0,0,0.14)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch'
    },
    cardHeader: {
        flex: '24px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        fontSize: 24,
        fontWeight: 100,
        margin: theme.spacing(1, 1, 0, 3)
    },
    cardBody: {
        flex: '1 0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch'      
    },    
    cardRow: {
        flex: '1 0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',                
        margin: '2px 18px',    
        padding: theme.spacing(0),    
        fontSize: 16,
        fontWeight: 300,
        color: '#000000',
        minHeight: '30px',
        maxHeight: '30px',
    },    
    cardColumn: {
        flex: '1 0',
        textAlign: 'left'
    },
    cardProfile: {
        flex: '1 0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',                
        margin: '10px',    
        padding: theme.spacing(0),    
        fontSize: 16,
        fontWeight: 400,
        color: '#172983',
        minHeight: '70px',
        maxHeight: '70px',
        minWidth: '180px',
        maxWidth: '180px',
        textAlign: 'center',
        backgroundColor: '#F8F9FA',
        borderRadius: '4px'        
    },
    cardProfileName: {
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '170px',
        textOverflow: 'ellipsis'        
    },
    cardUser: {
        flex: '1 0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',                
        margin: '0 10px',    
        padding: theme.spacing(0),    
        fontSize: 16,
        fontWeight: 400,
        color: '#172983',
        minHeight: '90px',
        maxHeight: '90px',
        minWidth: '180px',
        maxWidth: '180px',
        textAlign: 'center',
        textTransform: 'uppercase',
        backgroundColor: '#F8F9FA',
        borderRadius: '4px'
    },
    cardUserName: {
        fontWeight: 600,
        marginBottom: '10px'
    }
}));


const ViewActivity = () => {
    const history = useHistory();
    const classes = useStyles();
    const { appId }: any = useParams();    
    const { applicationSearchText, setApplicationSearchText, showErrorMessage } = useContext(AppContext);
    // const { currentUser } = useContext(UserContext);

    const { viewActivityData, getViewActivityData } = useContext(SecurityContext);

    const [isLoading, setLoading] = useState(true);

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);

    useEffect(() =>  {
        init();
    }, [appId]);

    const init = () => {
        if (appId) {
            setLoading(true);
            getViewActivityData(appId).catch(errorMessage => {
                showErrorMessage(errorMessage);
            }).finally(() => {
                setLoading(false);            
            });    
        } else {
            history.replace('/home');
        }
    };

    // const handleNewUser = () => {
    //     history.push('/manage/user/'+appId+'/new');
    // };
    
    const handleManageUsers = () => {
        history.push('/manage/users/'+appId);
    };    

    const handleManageProfiles = () => {
        history.push('/manage/profiles/'+appId);
    };    

    const handleViewUser = (user) => () => {
        history.push('/manage/user/'+appId+'/'+user.id);
    };


    const renderViewActivity = useMemo(() => <Grid container spacing={0} className={classes.body}>
        { viewActivityData && <>
            <Grid item xs={6}>
                <div className={classes.card} style={{minHeight: 250, maxHeight: 250}}>
                    <div className={classes.cardHeader}>
                        <span style={{color: '#000000'}}>Last Requests</span>
                        <Button variant="contained" color="primary" onClick={handleManageUsers}>Manage Users</Button>
                    </div>
                    <div className={classes.cardBody} style={{marginTop: '20px'}}>
                        { viewActivityData.lastRequests.length === 0 &&  <div className={classes.cardRow}>No request to display</div> }
                        { viewActivityData.lastRequests.map( user => { return   <div key={user.id} className={classes.cardRow}>
                            <span className={classes.cardColumn} style={{minWidth: 300}}>{user.firstName + ' ' + user.lastName}</span>
                            <span className={classes.cardColumn}>{user.company}</span>
                            <span className={classes.cardColumn}>{user.type}</span>
                            <Button variant="contained" className={classes.viewButton} onClick={handleViewUser(user)}>View</Button>
                        </div> })}                      
                    </div>               
                </div>
                <div className={classes.card} style={{minHeight: 155, maxHeight: 155}}>
                    <div className={classes.cardHeader}>
                        <span style={{color: '#000000'}}>Users</span>

                    </div>
                    <div className={classes.cardBody} style={{marginTop: '0px', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end'}}>
                        <div className={classes.cardUser}>
                            <span className={classes.cardUserName}>Active Users</span>
                            <span>{viewActivityData.users.active}</span>
                        </div>
                        <div className={classes.cardUser}>
                            <span className={classes.cardUserName}>Total N° of Users</span>
                            <span>{viewActivityData.users.total}</span>
                        </div>
                    </div>               
                </div>
            </Grid>
            <Grid item xs={6}>

                <div className={classes.card} style={{backgroundColor: '#333333', minHeight: 430, maxHeight: 430}}>
                    <div className={classes.cardHeader}>
                        <div>Activity<br/><span style={{fontSize: 16}}>N° of Connections</span></div>
                        <Button color="primary">Weekly</Button>
                    </div>
                    <div className={classes.cardBody}>
                        <Plot
                            data={[{ 
                                x: viewActivityData.weeklyConnections.x, 
                                y: viewActivityData.weeklyConnections.y, 
                                mode: 'lines+markers',  
                                type: 'scatter', 
                                line: { color: '#ADEAFE', width: 2 } 
                            }]}
                            layout={{ 
                                title: false, 
                                autosize: true, 
                                height: 350,
                                showgrid: false,
                                margin: { l: 10, r: 50, b: 50, t: 10, pad: 4 },
                                xaxis: { showgrid: false },  
                                yaxis: { side: 'right', showgrid: false },  
                                paper_bgcolor: '#333333',
                                plot_bgcolor: '#333333',
                                font: { size: 14, family: 'Roboto', color: '#CCCCCC' }
                            }}
                            config={{
                                showLink: false,
                                displayModeBar: false,
                                responsive: true
                            }}
                        />
                    </div>               
                </div>
            </Grid>
            <Grid item xs={12}>
                <div className={classes.card} style={{marginTop: '0px'}}>
                    <div className={classes.cardHeader}>
                        <span style={{color: '#000000'}}>Current Profiles</span>
                        <Button variant="contained" color="primary" onClick={handleManageProfiles}>Manage Profiles</Button>                      
                    </div>
                    <div className={classes.cardBody} style={{marginTop: '20px', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap'}}>
                        { viewActivityData.currentProfiles.map( profile => { return   <div key={profile.id} className={classes.cardProfile}>
                            <span className={classes.cardProfileName} title={profile.label}>{profile.label}</span>
                            <span>{profile.total}</span>
                        </div> })}
                    </div>               
                </div>
            </Grid>
        </>}
    </Grid>, [viewActivityData, isLoading]);    


    return (
        <Container className={classes.root} maxWidth="xl">
            <Grid container spacing={0} className={classes.header}>
                <span className={classes.title}>{viewActivityData && viewActivityData.name}</span>
                <div className={classes.toolbar}>
                    {/* { currentUser && currentUser.isSuperAdmin && <Button variant="contained" className={classes.gradientButton} style={{width: 150}} onClick={handleNewUser} >
                        Add User
                    </Button> } */}
                </div>
            </Grid>
            { renderViewActivity }          
            <LoadingOverlay open={isLoading} />
        </Container>
    );
};

export default ViewActivity;
